import React, { useEffect, useRef, useState } from 'react';
import classes from './landingVideo.module.scss';

const LandingVideo: React.FC = () => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(true); // State to track play status  

    const handlePlay = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play();
                setIsPlaying(true); // Update state to true when playing  
            } else {
                videoRef.current.pause();
                setIsPlaying(false); // Update state to false when paused  
            }
        }
    };

    // Function to prevent the right-click context menu  
    const preventRightClick = (event: MouseEvent) => {
        event.preventDefault();
    };

    // Effect to add event listener for right-click prevention  
    useEffect(() => {
        document.addEventListener('contextmenu', preventRightClick);

        // Cleanup function to remove the event listener  
        return () => {
            document.removeEventListener('contextmenu', preventRightClick);
        };
    }, []);
    return (
        <div className={classes.module}>
            <div className={classes.content} style={{ position: 'relative' }}>
                <video
                    ref={videoRef}
                    controls
                    loop
                    muted
                    playsInline
                    //onClick={handlePlay}
                    autoPlay
                >
                    <source src="https://txgenius-platform-assets.s3.ca-central-1.amazonaws.com/sample-new.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                {/* {!isPlaying && (  
                    <div className={classes.playButton} onClick={handlePlay}>  
                        ▶️ 
                    </div>  
                )}   */}
            </div>
        </div>
    );
};

export default LandingVideo;  